module.exports = __webpack_public_path__ + "static/media/student-summary-contender.3eb9f4ea.png";